export default {"faq":"vAfWT","accordionWrapper":"_2TWtj","accordionHeader":"_3Q79S","accordionBody":"MNS4a","allFAQsLink":"_0Ol-y"};